var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.228,
    height: 45.228,
    viewBox: "0 0 45.228 45.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(1484.239 -5801.096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 22.614,
    cy: 22.614,
    r: 22.614,
    transform: "translate(-1484.239 5801.096)",
    fill: "#444e7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(-1472.781 5811.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.2,76.134a3.907,3.907,0,0,1,.05-.653,5.3,5.3,0,0,1,.7-2.06c0-.05.05-.1.1-.151,1.859,2.01,3.669,3.97,5.528,5.98a1.307,1.307,0,0,0-.2,1.457c.05.151.151.352.2.5a11.586,11.586,0,0,0,1.256,1.809,41.278,41.278,0,0,0,2.915,3.015,20.645,20.645,0,0,0,2.261,1.91,3.475,3.475,0,0,0,.955.5,1.027,1.027,0,0,0,.854-.151.156.156,0,0,0,.1-.05c1.759,1.96,3.568,3.87,5.327,5.829a2.724,2.724,0,0,1-.9.5,6.362,6.362,0,0,1-1.407.3h-.955a7.567,7.567,0,0,1-1.809-.3,13.16,13.16,0,0,1-3.618-1.658,22.955,22.955,0,0,1-3.467-2.714,35.554,35.554,0,0,1-4.774-5.478A19.575,19.575,0,0,1,14.9,80.2a11.192,11.192,0,0,1-.6-2.563,2.865,2.865,0,0,0-.05-.653v-.754Z",
    transform: "translate(-14.2 -70.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16.761,72.86h.151a.955.955,0,0,1,.553.352c1.055,1.206,2.161,2.412,3.216,3.568.3.352.6.653.9,1.005a.927.927,0,0,1-.05,1.256c-.4.4-.8.754-1.206,1.156l-.352.352c-1.809-1.96-3.669-3.97-5.478-5.93l.1-.1,1.307-1.307a1.169,1.169,0,0,1,.6-.4h.251Z",
    transform: "translate(-12.992 -72.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M24.557,81.308a1.2,1.2,0,0,1-.452.653c-.5.452-.955.955-1.407,1.407l-.1.1c-1.809-1.96-3.568-3.87-5.377-5.829l.1-.1,1.457-1.457a.914.914,0,0,1,1.357,0C21.391,77.438,22.7,78.8,23.954,80.2c.1.1.2.251.3.352a.957.957,0,0,1,.251.5v.2Z",
    transform: "translate(-2.043 -60.855)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.c6167b287ef848bc1246b0c655f3bb93.svg";
export { ForwardRef as ReactComponent };